import React from 'react'

interface ColumnsProps {
  children: React.ReactNode
  gap?: 'small' | 'medium' | 'large'
  className?: string
}

interface ColumnProps {
  children: React.ReactNode
  width?: '1/2' | '1/3' | '2/3' | '1/4' | '3/4' | 'auto'
  className?: string
}

export const Columns: React.FC<ColumnsProps> = ({
  children,
  gap = 'medium',
  className = ''
}) => {
  const gapStyles = {
    small: 'gap-2',
    medium: 'gap-4',
    large: 'gap-8'
  }

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 ${gapStyles[gap]} my-6 ${className}`}>
      {children}
    </div>
  )
}

export const Column: React.FC<ColumnProps> = ({
  children,
  width = 'auto',
  className = ''
}) => {
  const widthStyles = {
    '1/2': 'md:col-span-6',
    '1/3': 'md:col-span-4',
    '2/3': 'md:col-span-8',
    '1/4': 'md:col-span-3',
    '3/4': 'md:col-span-9',
    'auto': 'md:col-span-auto'
  }

  // If width is auto, distribute evenly
  const colClass = width === 'auto' ? 'md:col-auto' : widthStyles[width]

  return (
    <div className={`col-span-12 ${colClass} ${className}`}>
      {children}
    </div>
  )
}